import { faqItems, cards, indexItems, comments, carouselItems, contactData, rankingItems } from '@/mocks/niuniuData';

export function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-6 w-full">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-medium text-accent-500 bg-accent-50 px-3 py-1 rounded-full mb-3">答疑解惑</span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">常见问题</h2>
          <p className="text-sm text-foreground-600 mt-2">关于牛牛影视，你想知道的都在这里</p>
        </div>
        <div className="space-y-3">
          {faqItems.map((item) => (
            <details key={item.id} className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4">{item.question}</h3>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-foreground-400 group-open:rotate-180 transition-transform">
                  <i className="ri-arrow-down-s-line text-lg"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1100px] mx-auto px-4 md:px-6 w-full">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-medium text-primary-500 bg-primary-50 px-3 py-1 rounded-full mb-3">精选片单</span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">主题推荐</h2>
          <p className="text-sm text-foreground-600 mt-2">精心策划的观影专题，找到你的下一部好片</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="sm:col-span-2 lg:col-span-2 lg:row-span-2 bg-background-100 border border-background-200 rounded-xl overflow-hidden group cursor-pointer hover:border-primary-300 transition-colors">
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=futuristic%20sci-fi%20cinematic%20scene%20with%20spaceship%20and%20distant%20planet%2C%20warm%20golden%20nebula%20background%2C%20epic%20scale%2C%20dramatic%20lighting%2C%20movie%20poster%20aesthetic%2C%20rich%20red%20and%20gold%20tones&width=800&height=600&seq=card-scifi&orientation=landscape"
                alt="科幻巨制推荐：未来已来"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5">
              <span className="text-xs bg-primary-100 text-primary-700 px-2 py-0.5 rounded-full font-medium">科幻</span>
              <h3 className="font-heading text-lg text-foreground-900 mt-2 mb-1">科幻巨制推荐：未来已来</h3>
              <p className="text-sm text-foreground-600">从《流浪地球》系列到《三体》，中国科幻电影的黄金时代已经到来</p>
            </div>
          </div>
          <div className="bg-background-100 border border-background-200 rounded-xl overflow-hidden group cursor-pointer hover:border-primary-300 transition-colors">
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=mysterious%20thriller%20movie%20aesthetic%20with%20shadowy%20figure%20and%20rainy%20alley%2C%20warm%20contrast%20lighting%2C%20film%20noir%20style%2C%20golden%20and%20deep%20red%20tones%2C%20suspenseful%20atmosphere&width=600&height=450&seq=card-thriller&orientation=landscape"
                alt="悬疑烧脑片单"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <span className="text-xs bg-accent-100 text-accent-700 px-2 py-0.5 rounded-full font-medium">悬疑</span>
              <h3 className="font-heading text-base text-foreground-900 mt-1.5 mb-1">悬疑烧脑片单</h3>
              <p className="text-xs text-foreground-600 line-clamp-2">15部让你看完怀疑人生的高能悬疑片</p>
            </div>
          </div>
          <div className="bg-background-100 border border-background-200 rounded-xl overflow-hidden group cursor-pointer hover:border-primary-300 transition-colors">
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Chinese%20animation%20art%20style%20with%20mythological%20creatures%20and%20fantasy%20landscape%2C%20vibrant%20warm%20colors%2C%20ink%20wash%20painting%20influence%2C%20golden%20light%2C%20dreamy%20atmosphere&width=600&height=450&seq=card-anime&orientation=landscape"
                alt="国漫崛起"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <span className="text-xs bg-primary-100 text-primary-700 px-2 py-0.5 rounded-full font-medium">国漫</span>
              <h3 className="font-heading text-base text-foreground-900 mt-1.5 mb-1">国漫崛起</h3>
              <p className="text-xs text-foreground-600 line-clamp-2">从《哪吒》到《深海》，国漫用实力证明世界级水准</p>
            </div>
          </div>
          <div className="bg-background-100 border border-background-200 rounded-xl overflow-hidden group cursor-pointer hover:border-primary-300 transition-colors">
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=warm%20family%20movie%20night%20scene%20with%20colorful%20animation%20characters%20and%20cozy%20living%20room%2C%20soft%20golden%20lighting%2C%20joyful%20atmosphere%2C%20children%20movie%20aesthetic&width=600&height=450&seq=card-family&orientation=landscape"
                alt="暑期亲子观影指南"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <span className="text-xs bg-accent-100 text-accent-700 px-2 py-0.5 rounded-full font-medium">亲子</span>
              <h3 className="font-heading text-base text-foreground-900 mt-1.5 mb-1">暑期亲子观影指南</h3>
              <p className="text-xs text-foreground-600 line-clamp-2">精选适合全家人一起看的20部电影</p>
            </div>
          </div>
          <div className="bg-background-100 border border-background-200 rounded-xl overflow-hidden group cursor-pointer hover:border-primary-300 transition-colors">
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=classic%20Hong%20Kong%20cinema%20aesthetic%20with%20neon%20signs%20and%20rainy%20street%2C%20vintage%20film%20texture%2C%20warm%20golden%20and%20red%20tones%2C%20nostalgic%201990s%20atmosphere&width=600&height=450&seq=card-hk&orientation=landscape"
                alt="港片经典回顾"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <span className="text-xs bg-primary-100 text-primary-700 px-2 py-0.5 rounded-full font-medium">港片</span>
              <h3 className="font-heading text-base text-foreground-900 mt-1.5 mb-1">港片经典回顾</h3>
              <p className="text-xs text-foreground-600 line-clamp-2">重温香港电影黄金时代的经典之作</p>
            </div>
          </div>
          <div className="bg-background-100 border border-background-200 rounded-xl overflow-hidden group cursor-pointer hover:border-primary-300 transition-colors">
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=documentary%20film%20aesthetic%20with%20globe%20and%20nature%20landscapes%2C%20warm%20earthy%20tones%2C%20cinematic%20realism%2C%20golden%20hour%20natural%20light%2C%20contemplative%20atmosphere&width=600&height=450&seq=card-doc&orientation=landscape"
                alt="高分纪录片"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <span className="text-xs bg-accent-100 text-accent-700 px-2 py-0.5 rounded-full font-medium">纪录片</span>
              <h3 className="font-heading text-base text-foreground-900 mt-1.5 mb-1">高分纪录片</h3>
              <p className="text-xs text-foreground-600 line-clamp-2">10部改变人生观的真实力作</p>
            </div>
          </div>
          <div className="bg-background-100 border border-background-200 rounded-xl overflow-hidden group cursor-pointer hover:border-primary-300 transition-colors">
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20drama%20cinematic%20scene%20with%20couple%20under%20cherry%20blossoms%2C%20warm%20romantic%20lighting%2C%20soft%20golden%20and%20pink%20tones%2C%20drama%20poster%20aesthetic%2C%20elegant%20composition&width=600&height=450&seq=card-kdrama&orientation=landscape"
                alt="韩剧入坑指南"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <span className="text-xs bg-primary-100 text-primary-700 px-2 py-0.5 rounded-full font-medium">韩剧</span>
              <h3 className="font-heading text-base text-foreground-900 mt-1.5 mb-1">韩剧入坑指南</h3>
              <p className="text-xs text-foreground-600 line-clamp-2">从《黑暗荣耀》到《破墓》，韩流入门必看</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1100px] mx-auto px-4 md:px-6 w-full">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-medium text-primary-500 bg-primary-50 px-3 py-1 rounded-full mb-3">快速导航</span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">影视分类索引</h2>
          <p className="text-sm text-foreground-600 mt-2">按类型快速找到你想看的内容</p>
        </div>
        <div className="grid grid-cols-3 md:grid-cols-5 gap-4">
          {indexItems.slice(0, 5).map((item) => (
            <a
              key={item.id}
              href="#"
              className="bg-background-50 border border-background-200 hover:border-primary-300 rounded-xl p-5 text-center group transition-colors cursor-pointer"
            >
              <div className="w-10 h-10 mx-auto mb-3 rounded-lg bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-xl text-primary-500`}></i>
              </div>
              <div className="text-sm font-medium text-foreground-800">{item.name}</div>
              <div className="text-xs text-foreground-500 mt-1">{item.count}</div>
            </a>
          ))}
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4">
          {indexItems.slice(5).map((item) => (
            <a
              key={item.id}
              href="#"
              className="bg-background-50 border border-background-200 hover:border-primary-300 rounded-xl p-5 text-center group transition-colors cursor-pointer"
            >
              <div className="w-10 h-10 mx-auto mb-3 rounded-lg bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-xl text-accent-500`}></i>
              </div>
              <div className="text-sm font-medium text-foreground-800">{item.name}</div>
              <div className="text-xs text-foreground-500 mt-1">{item.count}</div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6 w-full">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-medium text-accent-500 bg-accent-50 px-3 py-1 rounded-full mb-3">用户心声</span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">观众评价</h2>
          <p className="text-sm text-foreground-600 mt-2">来自真实用户的观影反馈</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {comments.map((c) => (
            <div key={c.id} className="bg-background-50 border border-background-200 rounded-xl p-5">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img src={c.avatar} alt={c.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-800">{c.name}</div>
                  <div className="text-xs text-foreground-500">{c.time}</div>
                </div>
              </div>
              <div className="flex gap-0.5 mb-2">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className={`text-xs ${i < c.rating ? 'text-primary-400 ri-star-fill' : 'text-foreground-300 ri-star-line'}`}></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{c.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1100px] mx-auto px-4 md:px-6 w-full">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-medium text-primary-500 bg-primary-50 px-3 py-1 rounded-full mb-3">深度内容</span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">焦点专题</h2>
          <p className="text-sm text-foreground-600 mt-2">编辑精选的深度影视专题内容</p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          <div className="lg:col-span-1 bg-background-50 border border-background-200 rounded-xl overflow-hidden group cursor-pointer hover:border-primary-300 transition-colors">
            <div className="aspect-[16/9] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=epic%20sci-fi%20cinematic%20scene%20with%20earth%20and%20massive%20space%20engines%2C%20dramatic%20lighting%2C%20warm%20golden%20sunlight%20on%20planet%20surface%2C%20movie%20poster%20quality%2C%20grand%20scale%2C%20rich%20textures&width=900&height=506&seq=carousel-01&orientation=landscape"
                alt="流浪地球3 深度解读"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-xs bg-primary-100 text-primary-700 px-2 py-0.5 rounded-full font-medium">深度解读</span>
                <span className="text-xs text-foreground-500">2026-07-30</span>
              </div>
              <h3 className="font-heading text-xl text-foreground-900 mb-1">流浪地球3 深度解读</h3>
              <p className="text-sm text-foreground-500 mb-3">数字生命 vs 流浪派：人类文明的终极抉择</p>
              <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">
                郭帆导演用三部曲构建了一个完整的未来世界观。从刹车时代到逃逸时代，再到太阳氦闪危机，流浪地球系列不仅是中国科幻的里程碑，更引发了对人类命运共同体的深层思考。
              </p>
            </div>
          </div>
          <div className="lg:col-span-1 space-y-5">
            <div className="bg-background-50 border border-background-200 rounded-xl overflow-hidden group cursor-pointer hover:border-primary-300 transition-colors flex flex-col sm:flex-row">
              <div className="sm:w-40 flex-shrink-0 aspect-[4/3] sm:aspect-auto overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=summer%20movie%20theater%20exterior%20with%20colorful%20posters%20and%20warm%20sunset%20light%2C%20festive%20atmosphere%2C%20golden%20hour%20tones%2C%20cinematic%20composition%2C%20vibrant%20yet%20warm&width=480&height=360&seq=carousel-02&orientation=landscape"
                  alt="2026暑期档：神仙打架"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-xs bg-accent-100 text-accent-700 px-2 py-0.5 rounded-full font-medium">观影指南</span>
                  <span className="text-xs text-foreground-500">2026-07-28</span>
                </div>
                <h3 className="font-heading text-base text-foreground-900 mb-1">2026暑期档：神仙打架</h3>
                <p className="text-xs text-foreground-600 line-clamp-2">15部大片扎堆上映，从国产科幻到好莱坞视效，今年暑期档堪称近年来最强阵容。</p>
              </div>
            </div>
            <div className="bg-background-50 border border-background-200 rounded-xl overflow-hidden group cursor-pointer hover:border-primary-300 transition-colors flex flex-col sm:flex-row">
              <div className="sm:w-40 flex-shrink-0 aspect-[4/3] sm:aspect-auto overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Chinese%20animation%20studio%20with%20artwork%20on%20walls%20and%20drawing%20table%2C%20warm%20creative%20workspace%20lighting%2C%20colorful%20character%20designs%2C%20golden%20afternoon%20light%2C%20artistic%20atmosphere&width=480&height=360&seq=carousel-03&orientation=landscape"
                  alt="国漫十年：从边缘到中心"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-xs bg-primary-100 text-primary-700 px-2 py-0.5 rounded-full font-medium">行业观察</span>
                  <span className="text-xs text-foreground-500">2026-07-25</span>
                </div>
                <h3 className="font-heading text-base text-foreground-900 mb-1">国漫十年：从边缘到中心</h3>
                <p className="text-xs text-foreground-600 line-clamp-2">中国动画如何用十年完成逆袭，从大圣归来到深海，回顾这段激动人心的崛起之路。</p>
              </div>
            </div>
            <div className="bg-background-50 border border-background-200 rounded-xl overflow-hidden group cursor-pointer hover:border-primary-300 transition-colors flex flex-col sm:flex-row">
              <div className="sm:w-40 flex-shrink-0 aspect-[4/3] sm:aspect-auto overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=vintage%20film%20projector%20in%20dark%20room%20with%20warm%20beam%20of%20light%2C%20classic%20cinema%20equipment%2C%20film%20reels%2C%20nostalgic%20golden%20glow%2C%20dramatic%20shadows%2C%20movie%20history%20aesthetic&width=480&height=360&seq=carousel-04&orientation=landscape"
                  alt="悬疑片爱好者必修课"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-xs bg-accent-100 text-accent-700 px-2 py-0.5 rounded-full font-medium">影史回顾</span>
                  <span className="text-xs text-foreground-500">2026-07-22</span>
                </div>
                <h3 className="font-heading text-base text-foreground-900 mb-1">悬疑片爱好者必修课</h3>
                <p className="text-xs text-foreground-600 line-clamp-2">从希区柯克到奉俊昊，横跨百年电影史梳理悬疑美学流变与叙事创新。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[700px] mx-auto px-4 md:px-6 w-full">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-medium text-accent-500 bg-accent-50 px-3 py-1 rounded-full mb-3">保持联系</span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">{contactData.title}</h2>
          <p className="text-sm text-foreground-600 mt-2">{contactData.subtitle}</p>
        </div>
        <div className="bg-background-100 border border-background-200 rounded-xl p-6 md:p-8">
          <p className="text-sm text-foreground-700 leading-relaxed mb-6 text-center">{contactData.desc}</p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="text-center p-4 bg-background-50 rounded-lg">
              <div className="w-10 h-10 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                <i className="ri-mail-line text-lg text-primary-500"></i>
              </div>
              <div className="text-xs text-foreground-500 mb-1">电子邮箱</div>
              <div className="text-sm font-medium text-foreground-800 break-all">{contactData.email}</div>
            </div>
            <div className="text-center p-4 bg-background-50 rounded-lg">
              <div className="w-10 h-10 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                <i className="ri-wechat-line text-lg text-accent-500"></i>
              </div>
              <div className="text-xs text-foreground-500 mb-1">微信公众号</div>
              <div className="text-sm font-medium text-foreground-800">{contactData.wechat}</div>
            </div>
            <div className="text-center p-4 bg-background-50 rounded-lg">
              <div className="w-10 h-10 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                <i className="ri-group-line text-lg text-primary-500"></i>
              </div>
              <div className="text-xs text-foreground-500 mb-1">QQ 交流群</div>
              <div className="text-sm font-medium text-foreground-800">{contactData.qqGroup}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-6 w-full">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-medium text-primary-500 bg-primary-50 px-3 py-1 rounded-full mb-3">实时热度</span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">热门榜单</h2>
          <p className="text-sm text-foreground-600 mt-2">基于播放量与讨论度的实时热度排行</p>
        </div>
        <div className="space-y-3">
          {rankingItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200 hover:border-primary-300 rounded-xl p-4 flex items-center gap-4 transition-colors cursor-pointer"
            >
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 font-bold text-lg ${
                item.rank === 1 ? 'bg-primary-500 text-white' :
                item.rank === 2 ? 'bg-accent-500 text-white' :
                item.rank === 3 ? 'bg-secondary-500 text-white' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm md:text-base font-medium text-foreground-900">{item.title}</h3>
                  <span className="text-xs bg-background-200 text-foreground-600 px-2 py-0.5 rounded-full whitespace-nowrap">{item.category}</span>
                  {item.trend === 'up' && <i className="ri-arrow-up-line text-primary-500 text-sm"></i>}
                  {item.trend === 'new' && <span className="text-xs text-accent-500 font-medium">NEW</span>}
                </div>
                <p className="text-xs text-foreground-600 mt-1 line-clamp-1">{item.desc}</p>
              </div>
              <div className="flex-shrink-0 text-right">
                <div className="text-lg font-bold text-primary-500">{item.hot}</div>
                <div className="text-xs text-foreground-500">热度分</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}